import React from 'react'
import {
	DragIndicator,
	FormatListBulleted,
	VerticalAlignCenter,
	LiveHelp,
	Image,
	Title,
	Code,
	Person,
} from '@material-ui/icons'
import { DragSource } from 'react-dnd'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core'
import { BookOpenPageVariant } from 'mdi-material-ui'

export const sections = [
	{ label: 'Open-ended question', Icon: LiveHelp, value: 'open' },
	{
		label: 'Multi-choice question',
		Icon: FormatListBulleted,
		value: 'multiple',
	},
	{ label: 'Separator', Icon: VerticalAlignCenter, value: 'separator' },
	{ label: 'Image', Icon: Image, value: 'image' },
	{ label: 'Title', Icon: Title, value: 'title' },
	{ label: 'Custom', Icon: Code, value: 'htmlcontent' },
	{ label: 'Page-break', Icon: BookOpenPageVariant, value: 'pagebreak' },
	{ label: 'Contact field', Icon: Person, value: 'contactfield' },
]

export const Section = DragSource(
	(props) => props.type,
	{
		beginDrag: (props) => {
			// props.expandFunnelStage(null)
			return { type: props.type, label: props.label }
		},
		canDrag: (props) => !props.disabled && props.draggable,
	},
	(connect, monitor) => ({
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging(),
	}),
)(
	({
		label,
		Icon,
		classes,
		disabled,
		connectDragSource,
		connectDragPreview,
		isDropped,
		isDragging,
		addSection,
		draggable,
	}) =>
		connectDragSource(
			<span
				id={`${label}-draggableFormPageSectionType`}
				style={{
					opacity: isDragging ? 0.4 : 1,
					borderRadius: 35,
					transform: 'translate(0, 0)',
				}}
				className={
					disabled
						? classNames(
								classes.sectionDisabled,
								'draggableFormPageSectionType',
						  )
						: draggable
						? classNames(classes.section, 'draggableFormPageSectionType')
						: classNames(
								classes.sectionUnDraggable,
								'draggableFormPageSectionType',
						  )
				}
				title={label}
				data={label}
			>
				<span onClick={() => addSection(label)}>
					{Icon || null}
					{label}
					<DragIndicator
						className={classNames(
							classes.sectionIcon,
							disabled
								? classes.dragIconDisabled
								: draggable
								? classes.dragIcon
								: classes.dragIconUnDraggable,
						)}
					/>
				</span>
			</span>,
		),
)

export const styles = (theme) => ({
	section: {
		cursor: 'grab',
		padding: '10px 0px 12px 10px',
		fontSize: 13,
		color: '#49466a',
		backgroundColor: '#d6e6f8',
		border: '2px solid #49466a',
		borderRadius: 35,
		display: 'inline-block',
		margin: 5,
		'&:hover': {
			backgroundColor: '#adbbed',
		},
	},
	sectionUnDraggable: {
		padding: '10px 0px 12px 10px',
		fontSize: 13,
		color: '#49466a',
		backgroundColor: '#d6e6f8',
		border: '2px solid #49466a',
		borderRadius: 35,
		display: 'inline-block',
		margin: 5,
		'&:hover': {
			backgroundColor: '#adbbed',
		},
	},
	sectionDisabled: {
		cursor: 'default',
		backgroundColor: '#edf5fe',
		color: '#787878',
		border: '2px solid #787878',
		padding: '10px 0px 12px 10px',
		fontSize: 13,
		borderRadius: 35,
		display: 'inline-block',
		margin: 5,
	},
	sectionIcon: {
		marginRight: 5,
		marginBottom: '-7px',
		fontSize: 22,
	},
	dragIcon: {
		fill: '#8e95af',
		cursor: 'grab',
	},
	dragIconUnDraggable: {
		fill: '#8e95af',
	},
	dragIconDisabled: {
		cursor: 'default',
	},
})

const Sections = ({ classes }) => {
	return (
		<div>
			<div style={{ marginBottom: 10, color: '#014c94' }}>
				Drag and drop the sections below to the desired preview area of your
				form.
			</div>
			{sections.map((section) => {
				const Icon = section.Icon

				return (
					<Section
						draggable
						key={`customFormSection-${section.value}`}
						type="sectionPill"
						Icon={<Icon className={classes.sectionIcon} />}
						classes={classes}
						disabled={false}
						label={section.label}
						addSection={() => console.log(section)}
					/>
				)
			})}
		</div>
	)
}

export default withStyles(styles)(Sections)
